import { useEffect, useState } from "react"
import API from "../../api"
import "./people-grid.component.css"
import ModalComponent from "../modal/modal.component"
import { Remarkable } from "remarkable"
import StrapiImageComponent from "../strapi-image/strapi-image.component"

const PeopleGridComponent = (props) => {
  const { Heading } = props
  const [people, setPeople] = useState([])
  const [selectedPerson, setSelectedPerson] = useState()

  // Fetch people
  useEffect(() => {
    const getPeople = async () => {
      try {
        const res = await API.getContent("leadership-team-members", null, {
          "populate[0]": "Headshot",
        })

        // Filter by env
        const host = window.location.host
        const isTest =
          host.indexOf("staging") > -1 || host.indexOf("localhost") > -1

        setPeople(
          res
            .filter(Boolean)
            .filter(
              (a) =>
                (isTest && a.attributes?.Environment === "Staging") ||
                (!isTest && a.attributes?.Environment === "Staging/Production"),
            )
            .sort((a, b) =>
              a.attributes?.OrderInGrid > b.attributes?.OrderInGrid ? 1 : -1,
            ),
        )
      } catch (e) {
        // todo handle error
      }
    }

    getPeople()
  }, [])

  const getSelectedPersonContent = () => {
    const md = new Remarkable()
    return (
      <div className="dagger-selected-person">
        <div className="dagger-selected-left">
          <h2>{selectedPerson.attributes.FullName}</h2>
          <h5>{selectedPerson.attributes.Title}</h5>
          <div className="dagger-person-image">
            <StrapiImageComponent
              attributes={selectedPerson.attributes.Headshot.data.attributes}
              alt={selectedPerson.attributes.FullName}
              sizes="(max-width: 800px) 100vw, 40vw"
            />
          </div>
        </div>
        <div className="dagger-selected-right">
          <div
            className="dagger-selected-right-bio"
            dangerouslySetInnerHTML={{
              __html: md.render(selectedPerson.attributes.Bio),
            }}
          ></div>
        </div>
      </div>
    )
  }

  return (
    <div className="dagger-people-grid">
      {selectedPerson && (
        <ModalComponent
          content={getSelectedPersonContent()}
          onClose={() => setSelectedPerson(false)}
        />
      )}
      <h1>{Heading}</h1>
      <ul>
        {people?.map((p) => {
          return (
            <li key={p.id} onClick={() => setSelectedPerson(p)}>
              <div className="dagger-person-image">
                <StrapiImageComponent
                  attributes={p.attributes?.Headshot?.data?.attributes}
                  alt={p.attributes?.FullName}
                  sizes="(max-width: 600px) 50vw, 25vw"
                />
              </div>
              <h5>{p.attributes?.FullName}</h5>
              <h6>{p.attributes?.Title}</h6>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default PeopleGridComponent
